export const hardcodedCloserBotProfile = {
  isBot: true,
  id: "closer",
  firstName: "Automatic Receptionist",
  lastName: "",
  avatarToken: undefined,
  email: "",
  orgRole: "",
};
